import { Input, Output, EventEmitter, Directive } from '@angular/core';

@Directive({
    selector: '[last-item]'
})
export class LastItemInLoopDirective {

  @Output() onLastItem = new EventEmitter<boolean>()

  @Input() set isLastItem(value: boolean) {
    if (value) {
        this.onLastItem.emit(true);
    }
  }

  constructor() {}
}
